module.exports = __webpack_public_path__ + "img/h.ffaa4899.png";